module.exports = __webpack_public_path__ + "files/d2ab0d09c6538eb3bcf2705ab8e81fce.png";